import React, { useState, useCallback } from 'react';
import Measure from 'react-measure';

import { cn, Button, Dropdown } from 'Modules/ui';

import styles from './index.module.scss';


export const Dock = ({ isCompact, onArrowClick, children }) => {
    const [height, setHeight] = useState(0);
    const updateHeight = useCallback(({ bounds }) => setHeight(bounds.height), []);
    return (
        <Measure bounds onResize={updateHeight}>
            {({ measureRef }) => (
                <div
                    className={cn(styles.dockContainer, isCompact && styles.collapsed)}
                    style={{ height }}
                >
                    <div
                        ref={measureRef}
                        className={cn(styles.dock, isCompact && styles.collapsed)}
                    >
                        <Button
                            variant='auxiliary'
                            className={cn(styles.arrow, 'hcenter')}
                            onClick={onArrowClick}
                        >
                            <Dropdown />
                        </Button>
                        <div className={styles.componentContainer}>
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </Measure>
    );
};

export const useDock = () => {
    const [showDock, setShowDock] = useState(false);
    const onArrowClick = useCallback(() => setShowDock(showDock => !showDock), []);
    const openDock = useCallback(() => setShowDock(true), []);
    return {
        openDock,
        isCompact: !showDock,
        onArrowClick,
    };
};
